import { Component, computed, input, resource } from '@angular/core';
import { ApiService } from '../api/api.service';
import { JsonPipe } from '@angular/common';
import { KENDO_LISTVIEW } from "@progress/kendo-angular-listview";
import { KENDO_LABEL } from "@progress/kendo-angular-label";
import { KENDO_DROPDOWNS } from "@progress/kendo-angular-dropdowns";
import { GridComponent, ColumnComponent, DataBindingDirective, CellTemplateDirective } from "@progress/kendo-angular-grid";
import { Button } from "@progress/kendo-angular-buttons";
import { DialogComponent, DialogActionsComponent } from "@progress/kendo-angular-dialog";
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { FormsModule } from '@angular/forms';
import { trashIcon } from '@progress/kendo-svg-icons';

function policiesSort (a: string[], b: string[]):number {
  if (a[2].localeCompare(b[2]) != 0) {
    return a[2].localeCompare(b[2]);
  }
  if (a[1].localeCompare(b[1]) != 0) {
    return a[1].localeCompare(b[1]);
  }

  return a[3].localeCompare(b[3]);
}

@Component({
  selector: 'user-rights',
  imports: [JsonPipe, FormsModule, KENDO_DROPDOWNS, KENDO_LISTVIEW, KENDO_LABEL, GridComponent, ColumnComponent, 
    Button, DialogComponent, DialogActionsComponent, TextBoxComponent, CellTemplateDirective],
  templateUrl: './user-rights.component.html',
  styleUrl: './user-rights.component.css',
})
export class UserRightsComponent {

  constructor(public apiService: ApiService) { }
  public trashIcon = trashIcon;

  public sub = input<string|undefined>(undefined);

  public rights = resource({
    params:() =>({
      sub: this.sub()
    }),
    loader: async ({params}) => {
      if (params.sub == undefined) {
        return undefined;
      }
      let result = await this.apiService.client.policies.getUserRights.query({sub: params.sub});
      return result;
    }
  })

  public policies = computed(() => {
    let r = this.rights.value();
    if (r == undefined) {
      return [];
    }
    return r.policies?.sort(policiesSort).map(p => {
      return {
        system: p[1],
        service: p[2],
        action: p[3]
      }
    }) || [];
  });

  public serviceAdmin = computed(() => {
    let r = this.rights.value();
    if (r == undefined) {
      return [];
    }
    return r.g?.map(p => ({service: p[2]})) || [];
  });

  public isAdmin = computed(() => {
    let r = this.rights.value();
    if (r == undefined) {
      return false;
    }
    return r.g2 && r.g2.length > 0;
  });

  public addPolicyDialogVisible = false;
  public newPolicy: {system: string, service: string, action: string} = {system: "", service: "", action: ""};
  public services: string[] = ["kopdata", "sercovision2"];  
  public actions: string[] = ["read", "write"];
  public async onPolicyAdd() {
    let sub = this.sub();
    if (sub == undefined) {
      return;
    }
    await this.apiService.client.policies.addPolicy.mutate({
      sub: sub,
      system: this.newPolicy.system,
      service: this.newPolicy.service,
      action: this.newPolicy.action
    });
    this.addPolicyDialogVisible = false;
    this.newPolicy = {system: "", service: "", action: ""};
    this.rights.reload();
  } 

  public async onPolicyDelete(policy: {system: string, service: string, action: string}) {
    let sub = this.sub();
    if (sub == undefined) {
      return;
    }
    await this.apiService.client.policies.removePolicy.mutate({
      sub: sub,
      system: policy.system,
      service: policy.service,
      action: policy.action
    });
    this.rights.reload();
  }

  public addServiceAdminDialogVisible = false;

  public async onAddServiceAdmin() {
    await this.apiService.client.policies.addServiceAdmin.mutate({
      sub: this.sub()!,
      service: this.newPolicy.service
    });
    this.rights.reload();
    this.newPolicy = {system: "", service: "", action: ""};
    this.addServiceAdminDialogVisible = false;
  }

  public async onRemoveServiceAdmin(service: string) {
    await this.apiService.client.policies.removeServiceAdmin.mutate({
      sub: this.sub()!,
      service: service
    });
    this.rights.reload();
  }


  public async onRemoveAdmin() {
    await this.apiService.client.policies.removeAdmin.mutate({
      sub: this.sub()!
    });
    this.rights.reload();
  }

  public async onMakeAdmin() {
    await this.apiService.client.policies.makeAdmin.mutate({
      sub: this.sub()!
    });
    this.rights.reload();
  }
}
